<template>
    <jet-select
        v-if="shouldShowAlertDropdown"
        v-model="form.alert_at"
        :horizontal="false"
        :invalid-feedback="form.errors.alert_at"
        :label="trans('quality_assurance.configuration.modal.alert_at.label')"
        :options="alertOptions.data || []"
        :resettable="false"
    />

    <jet-checkbox
        v-model="form.requires_approval"
        :invalid-feedback="form.errors.requires_approval"
        :label="trans('quality_assurance.configuration.modal.requires_approval.label')"
    />

    <jet-checkbox
        v-if="hasFeature('task_presence_detection')"
        v-model="form.requires_presence_detection"
        :invalid-feedback="form.errors.requires_presence_detection"
        :label="trans('quality_assurance.configuration.modal.requires_presence_detection.label')"
    />
</template>

<script setup>
import JetSelect from '@/Jetstream/Select.vue';
import JetCheckbox from '@/Jetstream/Checkbox.vue';
import { trans } from '@/mixins/i18n.js';
import { hasFeature } from '@/mixins/hasFeature.js';

defineProps({
    form: {
        type: Object,
        required: true,
    },
    alertOptions: {
        type: Object,
        required: false,
        default: () => ({ data: [] }),
    },
    shouldShowAlertDropdown: {
        type: Boolean,
        default: false,
    },
});
</script>
